import { CTABlockLayout } from '@modules/VanOord.CMS/Frontend/cmsPage/blocks/block/ctaBlock/ctaBlock.layout'
import 'intersection-observer'
import * as React from 'react'
import { Updater, IOWidget, fromJSX } from 'widgets-for-react'
import { CMSState, Url } from '../../../../cms/blocks/types.gen'

export type ColorCtaBlockProps = {
  index: number
  title?: string
  intro: string
  buttons: 'none' | 'primary' | 'primary_secondary'
  link_type: boolean
  primary_button?: {
    kind: 'link'
    is_link_external: boolean
    target: '_blank' | '_self'
    url: Url
  } & { title: string }
  secondary_button?: {
    kind: 'link'
    is_link_external: boolean
    target: '_blank' | '_self'
    url: Url
  } & { title: string }
  theme: 'green' | 'orange'
}

export function colorCtaBlock(
  props: ColorCtaBlockProps
): IOWidget<
  CMSState,
  Updater<CMSState>
> {
  return (cmsState: CMSState) =>
    fromJSX(() => {
        return (
          <CTABlockLayout
            id="cta-block-example"
            title={props.title}
            intro={props.intro}
            bgColour={props.theme}
            primaryUpdater={
              props.primary_button
                ? {
                    ...props.primary_button,
                    isExternal: props.primary_button.is_link_external
                  }
                : undefined
            }
            secondaryUpdater={
              props.secondary_button
                ? {
                    ...props.secondary_button,
                    isExternal: props.secondary_button.is_link_external
                  }
                : undefined
            }
          />
        )
      }
    )
}
